import { ACCESS_TOKEN } from "@/constants/normal";
import { UserRole } from "@/constants/user";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AuthState = {
  userId: number;
  userRole: UserRole;
  token: string | undefined;
};

type AuthAction = {
  setAuth: (values: AuthState) => void;
  setToken: (token: string) => void;
  clearAuth: () => void;
};

type AuthStore = AuthState & AuthAction;

const initialState: AuthState = {
  userId: -1,
  userRole: UserRole.guest,
  token: undefined,
};

const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      ...initialState,

      setAuth: ({ userId, userRole, token }) => {
        set({
          userId,
          userRole,
          token,
        });
      },
      setToken: (token) => {
        set({
          token,
        });
      },
      clearAuth: () => {
        set(initialState);
      },
    }),
    {
      name: ACCESS_TOKEN,
      version: 1,
      partialize: (state) => ({ token: state.token, userId: state.userId, userRole: state.userRole }),
    },
  ),
);

export default useAuthStore;
